var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBreast = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#333",
  strokeWidth: 1.5,
  transform: "translate(5 2)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.308 0A16.757 16.757 0 0 1 6.98 4.654c-.74 1.043-3.104 2.165-4.654 3.878-.604.667-1.197 1.88-1.551 2.327-.354.448-.776.24-.776.617s.776.276.776 1.71 1.017 2.429 1.55 3.102c.357.45 1.908 1.69 4.655 3.72M1 11.5l7-3.177"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 10.6)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m.5.77 9.757 1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11.785,
  cy: 1.785,
  r: 1.385
})), /*#__PURE__*/React.createElement("circle", {
  cx: 9.385,
  cy: 7.385,
  r: 1.385
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m1 11.5 7 4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9.385,
  cy: 16.385,
  r: 1.385
}))));
export { SvgBreast as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjEuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNSAyKSI+CiAgICAgICAgPHBhdGggc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNOS4zMDggMEExNi43NTcgMTYuNzU3IDAgMCAxIDYuOTggNC42NTRjLS43NCAxLjA0My0zLjEwNCAyLjE2NS00LjY1NCAzLjg3OC0uNjA0LjY2Ny0xLjE5NyAxLjg4LTEuNTUxIDIuMzI3LS4zNTQuNDQ4LS43NzYuMjQtLjc3Ni42MTdzLjc3Ni4yNzYuNzc2IDEuNzEgMS4wMTcgMi40MjkgMS41NSAzLjEwMmMuMzU3LjQ1IDEuOTA4IDEuNjkgNC42NTUgMy43Mk0xIDExLjVsNy0zLjE3NyIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMTAuNikiPgogICAgICAgICAgICA8cGF0aCBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik0uNS43N2w5Ljc1NyAxIi8+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjExLjc4NSIgY3k9IjEuNzg1IiByPSIxLjM4NSIvPgogICAgICAgIDwvZz4KICAgICAgICA8Y2lyY2xlIGN4PSI5LjM4NSIgY3k9IjcuMzg1IiByPSIxLjM4NSIvPgogICAgICAgIDxwYXRoIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTEgMTEuNWw3IDQiLz4KICAgICAgICA8Y2lyY2xlIGN4PSI5LjM4NSIgY3k9IjE2LjM4NSIgcj0iMS4zODUiLz4KICAgIDwvZz4KPC9zdmc+Cg==";